<template>
  <t-block-allow-email
    v-if="selectedCustomer.id"
    :id="selectedCustomer.id"
    :tier="TIER.domainGroups"
  ></t-block-allow-email>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import TBlockAllowEmail from "@/views/Common/TBlockAllowEmail";

import { TIER } from "@/constants/tier";

export default {
  name: "Emails",
  components: {
    TBlockAllowEmail,
  },
  data() {
    return {
      TIER,
    };
  },
  computed: {
    ...mapGetters("authentication", ["selectedCustomer"]),
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
    ...mapActions("modal", ["openModal", "closeModal"]),
  },
  mounted() {
    this.setPageTitle(this.$t("Allow & Block List"));
    this.setPageSubtitle([]);
  },
};
</script>
